import tw, { styled } from "twin.macro";

export const DonateWrapper = styled.div`
	height: "100%";
	width: "100%";
	display: flex;
	flex-direction: column;
	gap: 20px;
	overflow-y: scroll;
`;

export const InputContainer = styled.div`
	${tw`rounded-2xl p-4 flex-auto h-44 md:flex-1 flex flex-col gap-5 justify-center items-center`}
	min-height: 200px;
	width: 100%;
	border: 1px solid #f4f4f8;
	input {
		text-align: center;
		font-size: 2rem;
		border: none;
		caret-color: red;
		outline-color: transparent;

		&::focus-visible {
			border: none;
		}
	}
`;

export const LabelWrapper = styled.label`
	color: #c1cacf;
`;

export const HelperText = styled.span`
	margin-top: -18px;
	font-size: 0.75rem;
	color: red;
`;

export const AnonymousWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-top: -18px;
`;

export const PinkButton = styled.button`
	${tw`h-8 py-8 w-full px-5 flex items-center justify-center active:text-white hover:cursor-pointer text-sm bg-appPink rounded-2xl text-white border border-transparent font-bold focus:ring-2 hover:(ring-2 ring-appLightPink!) hover:bg-appPinkSaturated`}
`;

export const LightPinkButton = styled.button`
	${tw`h-8 py-8 w-full px-5 flex items-center justify-center active:text-white hover:cursor-pointer text-sm bg-appLightPink rounded-2xl text-appPink border border-transparent font-bold focus:ring-2 hover:(ring-2 ring-appLightPink!) hover:(bg-appGreenGauze)`}
`;

export const ButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	gap: 20px;
	flex-wrap: nowrap;
	width: 100%;
	flex: 1;
	@media (max-width: 768px) {
		flex-wrap: wrap;
	}
`;

export const DisclaimerText = styled.h5`
	${tw`text-center text-appPink mt-2 mb-6`}
`;

export const SecuredOptionText = styled.p`
	font-size: 0.875rem;
	margin-bottom: 0;
	display: flex;
	flex-direction: "row";
	justify-content: center;
	align-items: center;
	gap: 10px;
	font-weight: "bold";
`;
